import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { MySwal, AlertSwal, IconSwal } from '../CustomSwal';
import { FormattedMessage, useIntl } from 'react-intl';

function AppointmentAllModal(props) {
  const [data, setData] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const config = props.config;
  const formType = props.allData.spacetype ? config.SPACETYPE[`st_${props.allData.spacetype}`][0] : null;
  const formUserNumber = props.params.bookuser;
  const userid = sessionStorage.getItem('userid');
  const intl = useIntl();

  const GetAllDataByDate = () => {
    let sdate = props.allData.sdate;
    let edate = props.allData.edate;
    const params = {
      sid: sid,
      authid: authid,
      spacetype: props.allData.spacetype,
      zoneid: props.selectedzone ? props.selectedzone.zoneid : null,
      sdate: sdate ? sdate.split("/").join("") : null,
      edate: edate ? edate.split("/").join("") : null,
      restype: 'json'
    }
    props.setLoading(true);
    axios.get(config.API_URL + `/GetAllBookStatus.aspx`, {
      params: params
    }).then((res) => {
      const data = res.data;
      if (data.rescode === 3 || data.rescode === 4) {
        props.setSession(false);
      } else {
        if (data.rescode === 1) {
          let stateData = [];
          for (let i = 0; i < data.deviceinfo.length; i++) {
            stateData[i] = {
              bookinfo: [],
              deviceinfo: data.deviceinfo[i].deviceinfo,
              deviceid: data.deviceinfo[i].deviceid,
              devicename: data.deviceinfo[i].devicename,
              usetype: data.deviceinfo[i].usetype,
              zoneid: props.selectedzone ? null : data.deviceinfo[i].zoneid
            };
            for (let j = 0; j < data.bookvalue.length; j++) {
              stateData[i].bookinfo.push({
                bookdate: data.bookdate[j],
                booktime: data.booktime[j] || null,
                bookvalue: data.bookvalue[j],
                canbook: data.deviceinfo[i].canbook[j],
                closeday: data.deviceinfo[i].closeday[j],
                reason: data.deviceinfo[i].reason[j]
              })
            }
          }
          setData(stateData);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  const BookAdd = () => {
    // 檢查是否有選擇日期時間
    let bookvalues = document.querySelector('input[name="bookvalue"]:checked');
    if (bookvalues) {
      let swalMsg;
      let viewArr = [];
      let viewDates = [];
      let params = {};
      let selectedDeviceName = '';
      let bookvalue = '';
      // 取到選擇的 devicename
      data.find(elem => {
        if (elem.deviceid === selectedArea) {
          selectedDeviceName = elem.devicename;
        }
        return null;
      });
      // userids 整理
      let useridparam = '';
      if (parseInt(formUserNumber) === 1) {
        useridparam = userid;
      } else if (parseInt(formUserNumber) > 1) {
        useridparam = userid + ',' + props.allData.userids;
      }
      const checkboxes = document.getElementsByName('bookvalue');
      // 整理要送出的日期時間格式
      for (let i = 0, n = checkboxes.length; i < n; i++) {
        if (checkboxes[i].checked) {
          bookvalue += "," + checkboxes[i].value;
          viewArr.push(checkboxes[i].getAttribute('viewvalue'));
          viewDates.push(checkboxes[i].getAttribute('viewdate'));
        }
      }
      if (bookvalue) bookvalue = bookvalue.substring(1);
      // date time 參數 + swal 的內容 判別
      if (formType === 'date') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          bookdate: bookvalue,
          restype: 'json'
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{selectedDeviceName}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_date' })} : </span><span className="d-inline-block">{(viewArr.length === 1 ? viewArr[0] : `${viewArr[0]} ~ ${viewArr[viewArr.length - 1]}`)}</span>
          </div>
          ;
      } else if (formType === 'time') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          booktime: bookvalue,
          restype: 'json'
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{selectedDeviceName}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_date' })} : </span><span className="d-inline-block">{props.allData.sdate}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_time' })} : </span><span className="d-inline-block">{(viewArr.length === 1 ? viewArr[0].replace('~', ' ~ ') : `${viewArr[0].split('~')[0]} ~ ${viewArr[viewArr.length - 1].split('~')[1]}`)}</span>
          </div>
          ;
      } else if (formType === 'night') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          booktime: bookvalue,
          restype: 'json'
        }
        let datetimeText = '';
        if (viewArr.length === 1) {
          if (viewArr[0].split(' ').length > 1) {
            datetimeText = viewDates[0] + ' ' + viewArr[0].split(' ')[1].replace('~', ' ~ ');
          } else {
            datetimeText = viewDates[0] + ' ' + viewArr[0].replace('~', ' ~ ');
          }
        } else {
          let stext = '';
          let etext = '';
          if (viewArr[0].split(' ').length > 1) {
            stext = viewArr[0].split(' ')[1].split('~')[0];
          } else {
            stext = viewArr[0].split('~')[0];
          }
          if (viewArr[viewArr.length - 1].split(' ').length > 1) {
            etext = viewArr[viewArr.length - 1].split(' ')[1].split('~')[1];
          } else {
            etext = viewArr[viewArr.length - 1].split('~')[1];
          }
          if (viewDates[0] !== viewDates[viewArr.length - 1]) {
            datetimeText = viewDates[0] + ' ' + stext + ' ~ ' + viewDates[viewArr.length - 1] + ' ' + etext;
          } else {
            datetimeText = viewDates[0] + ' ' + stext + ' ~ ' + etext;
          }
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{selectedDeviceName}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_time' })} : </span><span className="d-inline-block">{datetimeText}</span>
          </div>
          ;
      }
      MySwal.fire({
        title: intl.formatMessage({ id: 'appointment.reservation_detail' }),
        html: swalMsg,
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
        cancelButtonText: intl.formatMessage({ id: 'global.cancel' })
      }).then((result) => {
        if (result.value) {
          props.setLoading(true);
          axios.get(config.API_URL + `/BookAdd.aspx`, {
            params: params
          }).then((res) => {
            const data = res.data[0];
            if (data.rescode === '3' || data.rescode === '4') {
              props.setSession(false);
            } else {
              if (data.rescode === '1') {
                props.setshow(false);
                if (config.SHOW_GOOGLE) {
                  IconSwal.fire({
                    title: intl.formatMessage({ id: 'appointment.success_reservation' }),
                    icon: 'success',
                    html: <span>{intl.formatMessage({ id: 'appointment.add_to_google' })}？</span>,
                    showCancelButton: true,
                    confirmButtonText: intl.formatMessage({ id: 'global.yes' }),
                    cancelButtonText: intl.formatMessage({ id: 'global.no' })
                  }).then((result) => {
                    if (result.value) {
                      const googleForm = document.getElementById('googleForm');
                      googleForm.querySelector('input[name=spacetype]').value = props.allData.spacetype;
                      googleForm.querySelector('input[name=deviceid]').value = selectedArea;
                      googleForm.querySelector('input[name=readerid]').value = userid;
                      googleForm.querySelector('input[name=booksdate]').value = (formType === 'date') ? viewDates[0] : props.allData.sdate;
                      googleForm.querySelector('input[name=bookedate]').value = (formType === 'date') ? viewDates[viewArr.length - 1] : props.allData.sdate;
                      googleForm.querySelector('input[name=binbooktime]').value = (formType === 'date') ? '' : bookvalue;
                      googleForm.submit();
                    }
                    props.setCurrent('info');
                    props.history.push('/redirect_to/info');
                  });
                } else {
                  IconSwal.fire({
                    title: intl.formatMessage({ id: 'appointment.success_reservation' }),
                    icon: 'success',
                    showCancelButton: false,
                    customClass: {
                      header: 'bg_swal swal-icon-header justify-content-around',
                      title: 'modal-title',
                      icon: 'swal-icon-class',
                      actions: 'modal-footer d-flex justify-content-center',
                      confirmButton: 'bg_brand btn btn-primary'
                    }
                  }).then((result) => {
                    props.setCurrent('info');
                    props.history.push('/redirect_to/info');
                  });
                }
              } else {
                let errMsg = data.resmsg.match(/\[(.*?)\]/);
                AlertSwal.fire({
                  title: intl.formatMessage({ id: 'global.alert_title' }),
                  text: errMsg ? intl.formatMessage({ id: `serverResponse.${errMsg[1]}` }) : intl.formatMessage({ id: 'serverResponse.default' }),
                  confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
                })
              }
            }
          }).catch((error) => {
            console.error(error)
          }).finally(() => {
            props.setLoading(false);
          })
        }
      })
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: 'global.alert_title' }),
        text: intl.formatMessage({ id: 'appointment.alert.select_period' }),
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
      })
    }
  }

  const handleChange = (elem) => {
    if (props.allData.enableToBook) {
      setSelectedArea(elem.currentTarget.value);
    }
  }

  useEffect(GetAllDataByDate, []);

  return (
    <Modal size='xl'
      show={props.show}
      onShow={() => {
        props.setShowScrollArrow(true);
      }}
      onHide={() => {
        props.setAllShow(false);
        props.setShowScrollArrow(false, 1);
      }}
      centered
      backdropClassName='double_modal_backdrop'
      dialogClassName="modal-95w"
      className='double_modal all_modal'
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>
          <span>
            <FormattedMessage
              defaultMessage={props.allData.zonename}
              id={props.selectedzone ?
                `global.zoneid.${props.selectedzone.zoneid}` :
                `global.spacetype.${props.allData.spacetype}`}
            />
            <FormattedMessage id='appointment.all_booking_list' />
          </span>
          <span>
            {props.allData.edate ?
              props.allData.sdate + ' ~ ' + props.allData.edate :
              props.allData.sdate}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Alert variant='danger' className='mb-2'>
              {props.allData.enableToBook ?
                <span className='d-block'><FormattedMessage id='appointment.all_modal_reminder' /></span>
                : null}
              <span className='d-inline-block'>
                <FormattedMessage id='appointment.max_value' />
                {
                  props.params.oncecanbooktime === '1' ?
                    <FormattedMessage id={'appointment.alert.' + (formType === 'date' ? 'reach_max_date_value' : 'reach_max_time_value')} values={{ value: props.params.oncecanbooktime }} />
                    :
                    <FormattedMessage id={'appointment.alert.' + (formType === 'date' ? 'reach_max_date_values' : 'reach_max_time_values')} values={{ value: props.params.oncecanbooktime }} />
                }
              </span>
            </Alert>
          </Col>
          {data === null ? <Col sm={12}>Loading</Col> :
            data.length === 0 ? <Col sm={12}>No Data Found</Col> :
              data.map((row, index) => {
                const isMac = config.IS_MAC_DEVICEID.find(elem => elem === row.deviceid) ? true : false;
                return (
                  <Col key={index} sm={12}>
                    <div className='d-flex align-items-center mb-1'>
                      {(row.deviceinfo !== '' && row.deviceinfo !== null) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              {row.deviceinfo}
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon information-icon'></i>
                        </OverlayTrigger>
                        : null}
                      {(row.usetype === 4) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.accessibility_space' />
                            </Tooltip>
                          }
                        >
                          <i className='deviceinfo-icon accessibility-icon'></i>
                        </OverlayTrigger>
                        : null}
                      {(isMac) ?
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              <FormattedMessage id='appointment.mac_device' />
                            </Tooltip>
                          }
                        >
                          <div style={{ margin: '-5px 0 0 -6px' }}>
                            <i className='deviceinfo-icon mac-icon'></i>
                          </div>
                        </OverlayTrigger>
                        : null}
                      <Form.Group controlId={`deviceRadio${index}`} className='device_radio'>
                        <Form.Check
                          inline
                          id={`deviceRadio${index}`}
                          name="device"
                          value={row.deviceid}
                          type="radio"
                          checked={selectedArea === row.deviceid}
                          label={
                            row.zoneid ?
                              `${intl.formatMessage({ id: `global.zoneid.${row.zoneid}` })}【${row.devicename}】 :`
                              :
                              `【${row.devicename}】:`
                          }
                          enabletobook={props.allData.enableToBook.toString()}
                          onChange={handleChange}
                        />
                      </Form.Group>
                      <Button className={selectedArea === row.deviceid ? 'bg_brand' : 'bg_brand d-none'} variant="primary" onClick={() => { BookAdd(); }}>
                        <FormattedMessage id='appointment.confirm_reservation_detail' />
                      </Button>
                    </div>
                    <AllCheckArea
                      data={row.bookinfo}
                      params={props.params}
                      enable={props.allData.enableToBook && (selectedArea === row.deviceid)}
                      formType={formType}
                      intl={intl}
                    />
                  </Col>
                )
              })}
        </Row>
      </Modal.Body>
      {props.allData.enableToBook ?
        <Modal.Footer className='d-flex justify-content-start'>
          <Button variant="light" onClick={() => {
            props.setAllShow(false);
            props.setShowScrollArrow(false, 1);
          }}><FormattedMessage id='global.back' /></Button>
        </Modal.Footer>
        : null}
    </Modal>
  )
}

function AllCheckArea(props) {
  const [checked, setChecked] = useState([]);
  const intl = props.intl;

  const handleCheck = (i) => {
    // 若 i 已勾選
    if (checked.find(elem => elem === i)) {
      // 取消勾選 i 及 i 以後的日期時間
      setChecked(checked.filter(elem => elem !== i && parseInt(elem) < parseInt(i)));
    } else {
      // 若 i 未勾選
      let newState = [];
      // 若目前有任何勾選 && 若 i 大於目前已勾選的最小值
      if (checked.length !== 0 && parseInt(i) > parseInt(checked[0])) {
        let cantBookInMiddle = null
        // 勾選所有 i 與 最小值之間的選項
        props.data.map((row, index) => {
          if (parseInt(row.bookvalue) <= parseInt(i) && parseInt(row.bookvalue) >= parseInt(checked[0])) {
            // 中間有無法預約的時段 ，記錄該 index
            if (row.canbook === 0 && cantBookInMiddle === null) {
              cantBookInMiddle = newState.length;
            }
            newState.push(row.bookvalue);
          }
          return null;
        })
        // 刪掉 index 後的 elem
        if (cantBookInMiddle) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: intl.formatMessage({ id: 'appointment.alert.middle_duplicate' }),
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          });
          newState = newState.splice(0, cantBookInMiddle);
        }
        // 刪掉超過最大天數的 elem
        if (props.formType === 'date') {
          if (newState.length > parseInt(props.params.oncecanbooktime)) {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
              html:
                `<span>` +
                intl.formatMessage({ id: 'appointment.alert.reach_max_date' }) +
                `<span class='d-inline-block'>` +
                intl.formatMessage({ id: 'appointment.alert.reach_max_date_value' }, {
                  value: props.params.oncecanbooktime
                }) + `</span></span>`
            });
            const delCount = newState.length - parseInt(props.params.oncecanbooktime);
            newState.splice(newState.length - delCount, newState.length)
          }
        } else {
          if ((newState.length / 2) > parseInt(props.params.oncecanbooktime)) {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
              html:
                `<span>` +
                intl.formatMessage({ id: 'appointment.alert.reach_max_time' }) +
                `<span class='d-inline-block'>` +
                intl.formatMessage({ id: 'appointment.alert.reach_max_time_value' }, {
                  value: props.params.oncecanbooktime
                }) + `</span></span>`
            });
            let delCount = ((newState.length / 2) - parseInt(props.params.oncecanbooktime)) * 2;
            newState.splice(newState.length - delCount, newState.length)
          }
        }
      } else {
        // 若未有任何勾選 || 若 i 小於最小值 
        // 只改為勾選 i
        newState.push(i);
      }
      // setChecked(prevState => [...prevState, i]);
      setChecked(newState);
    }
  }

  useEffect(() => {
    if (props.enable === false) {
      setChecked([]);
    }
  }, [props.enable]);

  let prevDate = '';
  return (
    <Row className="deviceArea">
      {props.data === null ? <Col sm={12}>Loading</Col> :
        props.data.length === 0 ? <Col sm={12}>No Data Found</Col> :
          props.data.map((row, index) => {
            let showDate = null;
            if (props.formType === 'night' && prevDate !== row.bookdate) {
              showDate = row.bookdate;
              prevDate = row.bookdate;
            }
            const isChecked = checked.find(elem => elem === row.bookvalue) ? true : false;
            return (
              <Col key={row.bookvalue} sm={6} md={4} lg={3} xl={2}>
                <Card border="dark"
                  onClick={() => {
                    if (props.enable) {
                      handleCheck(row.bookvalue);
                    }
                  }}
                  style={props.enable ? null : { pointerEvents: 'none' }}
                  className={row.canbook === 0 ? 'disabled' : null}
                >
                  <Card.Body className="d-flex justify-content-around align-items-center">
                    <div className="text-center device_info">
                      <b>{showDate} {props.formType === 'date' ? row.bookdate : row.booktime}</b>
                    </div>
                    {props.enable ?
                      <div>
                        <Form.Check viewdate={row.bookdate} viewvalue={props.formType === 'date' ? row.bookdate : row.booktime} name="bookvalue" value={row.bookvalue} aria-label={`bookvalue_${row.bookvalue}`} checked={isChecked} readOnly disabled={(row.canbook === 0)} />
                      </div>
                      : null}
                  </Card.Body>
                </Card>
              </Col>
            )
          })}
    </Row>
  )
}

export default AppointmentAllModal;